module.exports = __webpack_public_path__ + "static/media/ico-client-management.89a58716.svg";